import { XCircleIcon } from "@heroicons/react/24/solid";

export default function ProductUnavailable() {
    return (
        <div className="flex justify-center">
            <XCircleIcon className="h-5 w-5 text-red-400" />
        </div>
    );
}
